module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Ghost Hunter’s Guide"), _c('br'), _vm._v("\n  to"), _c('br'), _vm._v("\n  Seattle and"), _c('br'), _vm._v("\n  Puget Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("By Jeff Dwyer")]), _vm._v(" "), _c('p', {
    staticClass: "logo1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baf06578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_9781589805170_Title.vue
// module id = 60
// module chunks = 0